// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"165":"9b5b85ae","578":"ec20cebd","671":"6495f670"}[chunkId] + ".css";
};